export const initialState = {
  app: {
    status: "inactive", // inactive, active, error
    message: "",
  },
  feeds: {
    data: [],
    status: "pending", // pending, loading, error, success
  },
  communityInfo: {
    data: {},
    status: "pending", // pending, loading, error, success
  },
  childInfo: {
    data: {},
    status: "pending", // pending, loading, error, success
  },
  ListCommitments: {
    data: {},
    status: "pending", // pending, loading, error, success
  },
  communityNews: {
    data: {},
    status: "pending", // pending, loading, error, success
  },
  countryData: {
    data: {},
    status: "pending", // pending, loading, error, success
  },
  commitment: {
    data: {},
    status: "pending", // pending, loading, error, success
  },
  expandosStatus: {
    profile: false,
    community: false,
  },
  selectedCategory: "all",
  feedCategories: {
    child: [],
    community: [],
  }
};

export default initialState;